export default function nullifyEmptyArray<T>(
  arr: Array<T> | null | undefined
): Array<T> | null {
  return arr && arr.length > 0 ? arr : null;
}
